// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 99%;
}

.attendee-item {
  --padding-start: 0;
}
.attendee-item .position-note {
  font-size: 14px;
  font-family: var(--font);
  font-weight: 600;
  margin: auto 12px auto 0;
  text-align: center;
  width: 65px;
}
.attendee-item .point-note {
  margin: auto 5px;
}
.attendee-item .point-note .number {
  font-size: 16px;
  font-family: var(--font);
  font-weight: 600;
}
.attendee-item .point-note .pts {
  font-size: 14px;
  font-family: var(--font);
  font-weight: 400;
  margin-left: 4px;
}

ion-list {
  border-radius: 6px;
  padding: 20px 0px;
  margin: -15px 10px;
}
ion-list ion-text {
  font-weight: bold;
  text-align: center;
  font-size: 1rem;
  padding: 20px;
}

.item-highlighted {
  --background: var(--background-clr);
  --color: var(--myUser-color);
  background: var(--bg-color);
}

.sticky-item {
  position: sticky;
  top: 0;
  bottom: 0;
  z-index: 2;
}

ion-avatar {
  width: 48px;
  height: 48px;
}
ion-avatar .profile-picture {
  background: var(--bg-color);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  opacity: 0.6;
}
ion-avatar .profile-picture .cus-picture {
  width: 21px;
  height: 21px;
  margin: auto;
}

ion-searchbar {
  --icon-color: rgba(0,0,0,0.6);
  font-family: var(--font);
  font-weight: 400;
  width: 90%;
  margin: auto;
}

.podium-container {
  padding: 10px;
}

@keyframes Podium-Animation {
  from {
    height: 0%;
  }
  to {
    height: 100%;
  }
}
.podium-boxes {
  display: flex;
  align-items: flex-end;
  margin-top: 50px;
  height: 300px;
}
.podium-boxes > div {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  animation: Podium-Animation 3s linear forwards;
}
.podium-boxes strong {
  font-weight: bold;
  color: #FFF;
  font-size: 4rem;
}

.second-place {
  flex: 1;
  max-height: 40%;
  background: #5018F4;
  box-shadow: 0px -45px 0px 0px rgba(80, 24, 244, 0.7019607843);
}

.first-place {
  flex: 1;
  max-height: 55%;
  background: #83B43D;
  box-shadow: 0px -45px 0px 0px rgba(131, 180, 61, 0.7019607843);
}
.first-place strong {
  font-size: 5rem;
}

.third-place {
  flex: 1;
  max-height: 30%;
  background: #F4B619;
  box-shadow: 0px -45px 0px 0px rgba(244, 182, 25, 0.7019607843);
}

.attendee-on-podium {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 10px;
  position: absolute;
  top: -170px;
  left: 50%;
  transform: translateX(-50%);
}
.attendee-on-podium strong {
  margin-top: 10px;
  font-size: 1rem;
  max-width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #000;
}
.attendee-on-podium span {
  font-size: 0.865rem;
}

.second-place-avatar {
  width: 57px;
  height: 57px;
  box-shadow: 0 0 0 3px #C0C0C0;
}

.first-place-avatar {
  width: 64px;
  height: 64px;
  box-shadow: 0 0 0 3px #FFD700;
}

.third-place-avatar {
  width: 50px;
  height: 50px;
  box-shadow: 0 0 0 3px #CD7F32;
}

@media screen and (min-width: 768px) {
  .attendee-on-podium strong {
    max-width: 170px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/ranking/ranking.page.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;AACF;AAAE;EACE,eAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,wBAAA;EACA,kBAAA;EACA,WAAA;AAGJ;AAAE;EACE,gBAAA;AAEJ;AADI;EACE,eAAA;EACA,wBAAA;EAA0B,gBAAA;AAIhC;AAFI;EACE,eAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,gBAAA;AAKN;;AAAA;EACE,kBAAA;EACA,iBAAA;EACA,kBAAA;AAGF;AADE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AAGJ;;AACA;EACE,mCAAA;EACA,4BAAA;EACA,2BAAA;AAEF;;AACA;EAEE,gBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;AAEF;AADE;EACE,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AAGJ;AAFI;EACI,WAAA;EACA,YAAA;EACA,YAAA;AAIR;;AACA;EAEE,6BAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,UAAA;EACA,YAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE;IAAM,UAAA;EAGN;EAFA;IAAI,YAAA;EAKJ;AACF;AAHA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;AAKF;AAHE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8CAAA;AAKJ;AAFE;EACE,iBAAA;EACA,WAAA;EACA,eAAA;AAIJ;;AAAA;EACE,OAAA;EACA,eAAA;EACA,mBAAA;EACA,6DAAA;AAGF;;AAAA;EACE,OAAA;EACA,eAAA;EACA,mBAAA;EACA,8DAAA;AAGF;AADE;EACE,eAAA;AAGJ;;AACA;EACE,OAAA;EACA,eAAA;EACA,mBAAA;EACA,8DAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;AAEF;AAAE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAEJ;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;AAAF;;AAGA;EACE;IACE,gBAAA;EAAF;AACF","sourcesContent":["p {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 99%;\n}\n\n.attendee-item{\n  --padding-start: 0;\n  .position-note{\n    font-size: 14px;\n    font-family: var(--font); font-weight: 600;;\n    margin: auto 12px auto 0;\n    text-align: center;\n    width: 65px;\n  }\n  \n  .point-note{\n    margin: auto 5px;\n    .number{\n      font-size: 16px;\n      font-family: var(--font); font-weight: 600;;\n    }\n    .pts{\n      font-size: 14px;\n      font-family: var(--font); font-weight: 400;;\n      margin-left: 4px;\n    } \n  }\n}\n\nion-list {\n  border-radius: 6px;\n  padding: 20px 0px;\n  margin: -15px 10px;\n\n  ion-text {\n    font-weight: bold;\n    text-align: center;\n    font-size: 1rem;\n    padding: 20px;\n  }\n}\n\n.item-highlighted {\n  --background: var(--background-clr); \n  --color: var(--myUser-color);\n  background: var(--bg-color);\n}\n\n.sticky-item {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  bottom: 0;\n  z-index: 2;\n}\n\nion-avatar{\n  width: 48px;\n  height: 48px;\n  .profile-picture{\n    background: var(--bg-color);\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    display: flex;\n    opacity: 0.6;\n    .cus-picture{\n        width: 21px;\n        height: 21px;\n        margin: auto;\n    }\n  }\n}\n\nion-searchbar{\n  //--background: var(--bg-color);\n  --icon-color: rgba(0,0,0,0.6);\n  font-family: var(--font); font-weight: 400;;\n  width: 90%;\n  margin: auto;\n}\n\n.podium-container {\n  padding: 10px;\n}\n\n@keyframes Podium-Animation {\n  from {height: 0%; }\n  to {height: 100%;}\n}\n\n.podium-boxes {\n  display: flex;\n  align-items: flex-end;\n  margin-top: 50px;\n  height: 300px;\n\n  & > div { // each podium box\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    animation: Podium-Animation 3s linear forwards;\n  }\n\n  strong { \n    font-weight: bold;\n    color: #FFF;\n    font-size: 4rem;\n  }\n}\n\n.second-place {\n  flex: 1;\n  max-height: 40%;\n  background: #5018F4;\n  box-shadow: 0px -45px 0px 0px #5018f4b3;\n}\n\n.first-place {\n  flex: 1;\n  max-height: 55%;\n  background: #83B43D;\n  box-shadow: 0px -45px 0px 0px #83B43Db3;\n\n  strong {\n    font-size: 5rem;\n  }\n}\n\n.third-place {\n  flex: 1;\n  max-height: 30%;\n  background: #F4B619;\n  box-shadow: 0px -45px 0px 0px #F4B619b3;\n}\n\n.attendee-on-podium {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 10px;\n  position: absolute;\n  top: -170px;\n  left: 50%;\n  transform: translateX(-50%);\n\n  strong { // attendee-name\n    margin-top: 10px;\n    font-size: 1rem;\n    max-width: 100px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    color: #000;\n  }\n\n  span { // attendee-points\n    font-size: 0.865rem;\n  }\n}\n\n.second-place-avatar {\n  width: 57px; \n  height: 57px;\n  box-shadow: 0 0 0 3px #C0C0C0;\n}\n\n.first-place-avatar {\n  width: 64px; \n  height: 64px;\n  box-shadow: 0 0 0 3px #FFD700;\n}\n\n.third-place-avatar {\n  width: 50px; \n  height: 50px;\n  box-shadow: 0 0 0 3px #CD7F32;\n}\n\n@media screen and (min-width: 768px) {\n  .attendee-on-podium strong {\n    max-width: 170px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
